





















































































































































































































































import CMMFRowCode from '@/components/Promotions/CMMFRowCode.vue'
import TemplateItemCMMF from '@/components/Promotions/TemplateItemCMMF.vue'
import DatePicker from '@/components/shared/DatePicker.vue'
import codeFormat from '@/filters/cmmfCodeFormat'
import { dateShortFormat } from '@/filters/dateFormat'
import { capitalize } from '@/filters/stringFormat'
import BaseVue from '@/mixins/BaseVue'
import {
  CMMF,
  CMMFGroup,
  EBUStatus,
  EPromotionStatus,
  SelectedCMMF
} from '@/services/connecteur'
import promotionModule from '@/store/modules/PromotionModule'
import userModule from '@/store/modules/UserModule'
import moment from 'moment'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import CMMFImport from './CMMFImport.vue'

@Component({
  components: {
    CMMFImport,
    CMMFRowCode,
    TemplateItemCMMF,
    DatePicker
  },
  filters: {
    codeFormat,
    dateShortFormat
  }
})
export default class CMMFManagement extends Mixins(BaseVue) {
  @Prop()
  listOfCurrentSelectedCMMF!: SelectedCMMF[]

  @Prop()
  SalesOrgActive!: number

  @Prop()
  canAddCmmf!: boolean

  @Prop()
  canAcceptSupply!: boolean

  @Prop()
  canAcceptSupplyOnly!: boolean

  @Prop()
  disabled!: boolean

  @Prop()
  public promotionStatus!: EPromotionStatus

  @Prop()
  public snpCmmfs!: Array<string>

  public EBUStatus = EBUStatus

  // CMMF search local
  public textSearch = ''
  public cmmfGroupSearch: CMMFGroup | null = null
  public showRequiredActions = false
  public showFlaggedItems = false
  public showBuCheckItems = false

  // Data for autocomplete
  public resAutoComplete: CMMF | null = null
  public cmmfList: CMMF[] = []
  public isLoading = false
  public isPreloaded = false
  public cmmfGroup?: CMMFGroup | null = null
  public isInit = true

  // CMMF upload attributes
  public cmmfDialog = false

  public searchCmmfs: string | null = null;

  public quantity = 0

  public copyOfSelected: SelectedCMMF[] = []
  public headers: any[] = [
    {
      text: this.$t('promotionCMMF.header.productLine'),
      value: 'cmmfGroup'
    },
    {
      text: this.$t('promotionCMMF.header.familyLevelOne'),
      value: 'familyLevelOne'
    },
    {
      text: this.$t('promotionCMMF.header.longCommercialCode'),
      value: 'longCommercialCode'
    },
    { text: this.$t('promotionCMMF.header.code'), value: 'code' },
    {
      text: this.$t('promotionCMMF.header.productName'),
      value: 'productName'
    },
    {
      text: this.$t('promotionCMMF.header.plant'),
      value: 'plant'
    },
    { text: this.$t('promotionCMMF.header.quantity'), value: 'quantity' },
    { text: this.$t('promotionCMMF.header.kamComment'), value: 'kamComment' },
    {
      text: this.$t('promotionCMMF.header.dpComment'),
      value: 'dpComment'
    },
    {
      text: this.$t('promotionCMMF.header.snpComment'),
      value: 'snpComment'
    },
    {
      text: this.$t('promotionCMMF.header.supplyDeadline'),
      value: 'supplyDeadline'
    },
    {
      text: this.$t('promotionCMMF.header.actions'),
      align: 'center',
      value: 'actions',
      sortable: false
    }
  ]

  public mounted () {
    this.cmmfGroup = undefined
  }

  public get cmmfHaveT2Status () {
    if (this.resAutoComplete) {
      return this.resAutoComplete?.sdStatus === 'T2'
    }
    return false
  }

  public get cmmfGroupName () {
    return promotionModule.cmmfGroupName
  }

  @Watch('listOfCurrentSelectedCMMF')
  public onCurrentCmmfUpdate () {
    // Force le rafraichissement de la liste si les ids ont été modifiés.
    if (this.listOfCurrentSelectedCMMF && this.copyOfSelected && JSON.stringify(this.listOfCurrentSelectedCMMF) !== JSON.stringify(this.copyOfSelected)) {
      this.isPreloaded = false
    }
  }

  public get selectedCMMF () {
    if (
      this.listOfCurrentSelectedCMMF &&
      this.listOfCurrentSelectedCMMF.length > 0 &&
      !this.isPreloaded
    ) {
      this.copyOfSelected = [...this.listOfCurrentSelectedCMMF]
      this.isPreloaded = true
    }

    let result = this.copyOfSelected
    if (this.textSearch) {
      result = result.filter(
        c =>
          this.compareToSearch(c.longCommercialCode) ||
          this.compareToSearch(c.code) ||
          this.compareToSearch(c.familyLevelOne) ||
          this.compareToSearch(c.plant) ||
          this.compareToSearch(c.productName) ||
          this.compareToSearch(this.getFamilyCode(c))
      )
    }

    if (this.cmmfGroupSearch || this.cmmfGroupSearch === 0) {
      result = result.filter(c => c.cmmfGroup === this.cmmfGroupSearch)
    }

    if (this.showRequiredActions) {
      result = result.filter(
        c => c.acceptSupply !== undefined && !c.acceptSupply
      )
    }

    if (this.showFlaggedItems) {
      result = result.filter(c => c.flagSupply !== undefined && c.flagSupply)
    }

    if (this.showBuCheckItems) {
      result = result.filter(c => c.buStatus !== undefined && c.buStatus !== null && c.buStatus === EBUStatus.ASKED)
    }

    return result
  }

  public getFamilyCode (selectedCmmf: SelectedCMMF) {
    const cmmfs = this.cmmfList.filter(c => c.code === selectedCmmf.code)
    if (cmmfs.length) {
      return cmmfs[0].familyCode
    }
    return '-'
  }

  public compareToSearch (value: string | undefined): boolean {
    let result = true
    if (this.textSearch) {
      result =
        value !== undefined &&
        value !== null &&
        value !== '' &&
        value.toUpperCase().includes(this.textSearch.toUpperCase())
    }
    return result
  }

  public get minSupplyDate (): string {
    return moment().toISOString()
  }

  public resetBuCheck (cmmf: SelectedCMMF) {
    cmmf.buStatus = undefined
    cmmf.supplyDeadline = undefined
  }

  public addTolistCMMF () {
    if (this.resAutoComplete && this.quantity !== 0) {
      this.copyOfSelected.push(
        new SelectedCMMF({
          cmmfId: this.resAutoComplete.id,
          longCommercialCode: this.resAutoComplete.longCommercialCode,
          familyLevelOne: this.resAutoComplete.familyCode,
          plant: this.resAutoComplete.plant,
          productName: this.resAutoComplete.productName,
          cmmfGroup: this.resAutoComplete.cmmfGroup,
          code: this.resAutoComplete.code,
          quantity: Number(this.quantity),
          kamComment: '',
          acceptSupply: false,
          flagSupply: false,
          dpComment: '',
          snpComment: '',
          supplyDeadline: undefined
        })
      )
      this.resAutoComplete = null
      this.quantity = 0
      this.searchCmmfs = null
    }
  }

  public addCmmfs (cmmfs: SelectedCMMF[]) {
    cmmfs.forEach(cmmf => this.copyOfSelected.push(cmmf))
  }

  public canSwitchBuStatus (cmmf: SelectedCMMF) {
    if (this.canAddCmmf || this.disabled) {
      return false
    }
    if (this.isBuCheck) {
      return cmmf.buStatus !== null &&
        (
          userModule.userIsAdmin ||
          (cmmf.code && this.snpCmmfs.includes(cmmf.code))
        )
    }
    return cmmf.buStatus !== EBUStatus.APPROVED &&
      cmmf.buStatus !== EBUStatus.DENIED
  }

  public swithBuStatus (cmmf: SelectedCMMF, status?: EBUStatus) {
    if (this.canSwitchBuStatus(cmmf)) {
      if (!this.isBuCheck) {
        cmmf.buStatus = cmmf.buStatus !== EBUStatus.ASKED ? EBUStatus.ASKED : undefined
      } else {
        const currentStatus = status ?? cmmf.buStatus
        switch (currentStatus) {
          case EBUStatus.ASKED:
            cmmf.buStatus = EBUStatus.APPROVED
            break
          case EBUStatus.APPROVED:
            cmmf.buStatus = EBUStatus.DENIED
            cmmf.supplyDeadline = undefined
            break
          case EBUStatus.DENIED:
            cmmf.buStatus = EBUStatus.ASKED
            break
          default:
            cmmf.buStatus = EBUStatus.ASKED
        }
      }
    }
  }

  public get isBuCheck () {
    return !this.disabled && !this.canAddCmmf && !this.canAcceptSupply
  }

  public getBuStatusLabel (cmmf: SelectedCMMF) {
    const action = this.canSwitchBuStatus(cmmf)
      ? (this.isBuCheck ? 'actionSnp' : 'actionDp')
      : 'readonly'
    const value = cmmf.buStatus !== undefined && cmmf.buStatus !== null
      ? capitalize(EBUStatus[cmmf.buStatus])
      : 'Empty'
    return this.$t(`promotionCMMF.buCheck.${action}${value}`)
  }

  public updateSelectedCMMF (value: {
    old: SelectedCMMF
    new: SelectedCMMF
  }) {
    const itemIndex = this.copyOfSelected.indexOf(value.old)
    this.resetBuCheck(value.new)
    this.copyOfSelected.splice(itemIndex, 1, value.new)
  }

  public removeCMMF (item: SelectedCMMF) {
    const itemIndex = this.copyOfSelected.indexOf(item)
    this.copyOfSelected = this.copyOfSelected.filter(function (el, index) {
      return index !== itemIndex
    })
  }

  @Watch('copyOfSelected', { deep: true })
  public checkCmmfsFlags () {
    this.$emit('update:listeCMMFSelect', this.copyOfSelected)
  }

  @Watch('listOfCurrentSelectedCMMF')
  public refreshCmmfList (oldValue: any, newValue: any) {
    if (oldValue && newValue && JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
      this.copyOfSelected = this.listOfCurrentSelectedCMMF.slice()
    }
  }

  @Watch('SalesOrgActive', { immediate: true })
  public async salesOrdIdUpdated () {
    this.loadCmmfs()
  }

  @Watch('disabled', { immediate: true })
  public async disabledUpdated () {
    this.loadCmmfs()
  }

  public get searchedCmmfs() {
    const search = (this.searchCmmfs && this.searchCmmfs.trim() !== '') ? this.searchCmmfs.toUpperCase() : null
    const list = this.cmmfList.filter((cmmf) => {
    const lcode = cmmf.longCommercialCode?.toUpperCase() ?? ''
    const code = cmmf.code?.toUpperCase() ?? ''
    const name = cmmf.productName?.toUpperCase() ?? ''
      return (!search || [lcode, code, name].join(' ').includes(search)) && (!this.cmmfGroup || this.cmmfGroup === cmmf.cmmfGroup)
    })
    return list
  }

  public async loadCmmfs () {
    if (this.SalesOrgActive > 0 && !this.disabled) {
      this.isLoading = true
      try {
        const result = await promotionModule.loadCMMF(this.SalesOrgActive)
        this.cmmfList = result
      } catch (error) {
        this.displayError(error)
        this.isLoading = false
      }
    }
     this.isLoading = false
    this.showBuCheckItems = this.isBuCheck
  }

  public changeAllCmmfStatus (accepted?: boolean | null, status?: EBUStatus | null): boolean {
    this.copyOfSelected.forEach(c => {
      if (status !== null) {
        this.swithBuStatus(c, status ?? EBUStatus.DENIED)
      } else {
        c.acceptSupply = accepted === true
        c.flagSupply = accepted === false

        if (accepted == null && c.buStatus !== EBUStatus.ASKED || accepted !== null && c.buStatus === EBUStatus.ASKED) {
          this.swithBuStatus(c)
        }
      }
    })
    return false
  }
}
